import { NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GoogleMap } from '@angular/google-maps';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../misc/misc.module';
import { HomePageRoutingModule } from './home-routing.module';
import { HomePageComponent } from './home.page';

@NgModule({
  declarations: [HomePageComponent],
  imports: [MiscModule, FormsModule, IonicModule, HomePageRoutingModule, GoogleMap, NgClass]
})
export class HomePageModule {}
